

export class SimCardUpdateInput implements ISimCardUpdateInput {
    /** The auto-generated id of the sim card details master */
    simCardDetailsId!: number;
    /** The auto-generated id of the branch details master */
    branchDetailId!: number;
    /** The card number with 255 character limit */
    cardNumber!: string;
    /** The auto-generated id of the tariff plan master */
    tariffPlanId!: number;
    /** The IMSI number with 255 character limit */
    imsiNumber!: string;
    /** The card activation date */
    cardActivationDate!: number;
    /** The card expiry date */
    cardExpiryDate!: number;
    /** The GPRS last activation date */
    gprsLastActivationDate!: number;
    /** The GPRS expiry date */
    gprsExpiryDate!: number;

    constructor(data?: ISimCardUpdateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.simCardDetailsId = _data["simCardDetailsId"];
            this.branchDetailId = _data["branchDetailId"];
            this.cardNumber = _data["cardNumber"];
            this.tariffPlanId = _data["tariffPlanId"];
            this.imsiNumber = _data["imsiNumber"];
            this.cardActivationDate = _data["cardActivationDate"];
            this.cardExpiryDate = _data["cardExpiryDate"];
            this.gprsLastActivationDate = _data["gprsLastActivationDate"];
            this.gprsExpiryDate = _data["gprsExpiryDate"];
        }
    }

    static fromJS(data: any): SimCardUpdateInput {
        data = typeof data === 'object' ? data : {};
        let result = new SimCardUpdateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["simCardDetailsId"] = this.simCardDetailsId;
        data["branchDetailId"] = this.branchDetailId;
        data["cardNumber"] = this.cardNumber;
        data["tariffPlanId"] = this.tariffPlanId;
        data["imsiNumber"] = this.imsiNumber;
        data["cardActivationDate"] = this.cardActivationDate;
        data["cardExpiryDate"] = this.cardExpiryDate;
        data["gprsLastActivationDate"] = this.gprsLastActivationDate;
        data["gprsExpiryDate"] = this.gprsExpiryDate;
        return data; 
    }
}

export interface ISimCardUpdateInput {
    /** The auto-generated id of the sim card details master */
    simCardDetailsId: number;
    /** The auto-generated id of the branch details master */
    branchDetailId: number;
    /** The card number with 255 character limit */
    cardNumber: string;
    /** The auto-generated id of the tariff plan master */
    tariffPlanId: number;
    /** The IMSI number with 255 character limit */
    imsiNumber: string;
    /** The card activation date */
    cardActivationDate: number;
    /** The card expiry date */
    cardExpiryDate: number;
    /** The GPRS last activation date */
    gprsLastActivationDate: number;
    /** The GPRS expiry date */
    gprsExpiryDate: number;
}

